import '../../img/ajax-loader.gif';
import '../../img/favicon.ico';
import '../../img/placeholder.jpg';